/* eslint react/jsx-key: off */
import React from 'react';
import {
  Edit,
  FormTab,
  TabbedForm,
  TextInput,
  required,
  NumberInput,
  Toolbar,
  SaveButton,
  //   Datagrid,
  //   TextField,
  CardActions
} from 'react-admin';
import {withStyles} from '@material-ui/core';
import BackButton from '../common/BackButton';

export const styles = {
  name: {display: 'inline-block'},
  email: {width: 544},
  phone: {width: 544},
  first_name: {
    width: 480,
    maxWidth: '100%',
    '& .MuiFormControl-root': {
      width: '100%'
    },
    '& .MuiFormLabel-root': {
      whiteSpace: 'nowrap',
      maxWidth: 'calc(100% - 24px)'
    },
    '& .MuiInputLabel-root': {
      whiteSpace: 'nowrap',
      maxWidth: 'calc(100% - 24px)'
    }
  }
};

const toolbarStyles = {
  toolbar: {
    display: 'flex',
    justifyContent: 'space-between'
  }
};

const ServiceCategoryEditToolbar = withStyles(toolbarStyles)(({...props}) => (
  <Toolbar {...props}>
    <SaveButton />
  </Toolbar>
));

const ListActions = () => (
  <CardActions>
    <BackButton />
  </CardActions>
);
const ServiceCategoryEdit = ({classes, ...props}) => (
  <Edit title="Edit Service Category" {...props} actions={<ListActions />}>
    <TabbedForm toolbar={<ServiceCategoryEditToolbar />}>
      <FormTab label="">
        <TextInput disabled source="serviceCategoryName" formClassName={classes.first_name} fullWidth />
        <TextInput source="serviceCode" formClassName={classes.first_name} fullWidth />
        <NumberInput
          autoFocus
          source="profitPercentage"
          label="Profit Percentage"
          validate={required()}
          formClassName={classes.first_name}
          fullWidth
        />
        <NumberInput
          source="commissionThreshold"
          label="Commission Threshold Amount"
          formClassName={classes.first_name}
          fullWidth
        />
        <NumberInput
          source="fixedCommission"
          label="Fixed Commission Above Threshold"
          formClassName={classes.first_name}
          fullWidth
        />
      </FormTab>
    </TabbedForm>
  </Edit>
);

ServiceCategoryEdit.propTypes = {};

export default withStyles(styles)(ServiceCategoryEdit);
